import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';
import ptBR from './locales/pt-BR/common.json';
import es from './locales/es/common.json';
import en from './locales/en/common.json';

i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    fallbackLng: 'pt-BR',
    debug: false,
    resources: {
      'pt-BR': { translation: ptBR },
      es: { translation: es },
      en: { translation: en },
    },
    interpolation: { escapeValue: false },
  });

export default i18n;
